import React, { useEffect, memo } from "react";
import { useCedulasContext } from "Context/CedulasPageContext";
import { useGlobalContext } from "Context/GlobalContext.js"; 
import LightTooltip from 'Utils/LightTooltip.jsx'
import CloseIconSelect from 'Utils/CloseIconSelect.jsx';
import styles from './styles.js';
import { styled } from '@mui/system';
import { InputLabel, MenuItem, Select, Fade, FormControl } from '@mui/material';

const PickerContainer = styled(FormControl)(() => (styles.formControl));

const EstatusFilter = () => {
    const { isSmallScreen } = useGlobalContext()
    const { 
        estatusWithCedulas, selectedEstatus, handleSelectedEstatus,
        cedulasData, handleEstatusWithCedulas,
    } = useCedulasContext();
    
    const handleCleanFilters = (_event) => {
        handleSelectedEstatus("")
    }

    useEffect(() => {
        handleEstatusWithCedulas()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <PickerContainer size="small" sx={{ width: '100%' }}>
            <InputLabel id="seleccionar-estatus-filtro">
                Estatus de la Persona
            </InputLabel>
            <LightTooltip 
                title="
                    Corresponde al estatus actual de la persona. Si no agregas otros criterios, se mostrarán todas las cédulas con el estatus seleccionado. 
                " 
                placement={isSmallScreen ? "top" : "right"} 
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 600 }}
                arrow
            >
                <Select
                    labelId="seleccionar-estatus-filtro"
                    id="seleccionar-estatus-filtro"
                    value={selectedEstatus}
                    label="Estatus de la Ficha"
                    onChange={(event) =>
                        handleSelectedEstatus(event.target.value)
                    }
                    endAdornment={<CloseIconSelect dataCondition={selectedEstatus} dataFuntion={handleCleanFilters}/>}
                > {
                    !cedulasData.loadingEstatusCedula && estatusWithCedulas.map((estatus) => (
                        <MenuItem key={estatus.id} value={estatus.id}>{estatus.label_front}</MenuItem>
                    ))
                }</Select>
            </LightTooltip>
        </PickerContainer>
    )
}

const MemoEstatusFilter = memo(EstatusFilter);

export default MemoEstatusFilter;
